import React, { useState, useEffect }  from 'react';
import axios from 'axios';
// Bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css';
//
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
// Datetime picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from 'react-bootstrap/Table'
// Generación Excel
import * as XLSX from 'xlsx';
import { startOfWeek, endOfWeek, format } from 'date-fns';

const ReporteOmisionesForm = ({usuario, apiUrl})=>{
    const [proyectoSelected, setProyectoSelected] = useState(0)
    const dateFechaInicial = new Date();
    dateFechaInicial.setHours(0, 0, 0, 0);
    const dateFechaFinal = new Date();
    dateFechaFinal.setHours(23, 59, 59, 999);
    const [fechaInicioSelected, setFechaInicioSelected] = useState(dateFechaInicial);
    const [fechaFinSelected, setFechaFinSelected] = useState(dateFechaFinal);
    //
    const [selectedDate, setSelectedDate] = useState(dateFechaInicial)
    //
    const [proyectos, setProyectos] = useState([]);


    const exportarDatos = (datos) => {
        if (datos.length === 0) {
            alert('Tu consulta no retornó registros.')
        }
        else {
            const date = new Date(fechaInicioSelected);
            const date2 = new Date(fechaFinSelected);
            //
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDateInicio = `${year}${month}${day}`;
            //
            const year2 = date2.getFullYear();
            const month2 = String(date2.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const day2 = String(date2.getDate()).padStart(2, '0');
            const formattedDateFin = `${year2}${month2}${day2}`;
            //
            const ws = XLSX.utils.json_to_sheet(datos);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, `omisiones de usuarios.xlsx`);
            XLSX.writeFile(wb, `${formattedDateInicio}_${formattedDateFin}_omisiones_usuarios.xlsx`);
        }
    }

    const exportarReporte = () => {
        axios.post(`${apiUrl}/horaslaboradas/obtenReporteOmisiones?token=${sessionStorage.getItem('token')}`, 
            {
                idProyecto: proyectoSelected,
                fechaInicio: fechaInicioSelected,
                fechaFin: fechaFinSelected,
            })
            .then((objResponse) => {
                exportarDatos(objResponse.data.result);
            })
            .catch((error) => {
                alert('hubo un error al recuperar las horas de los proyectos: ' + error.response.data)
            });
                
    }

    const obtenerProyectos = () => {
        axios
            .post(`${apiUrl}/proyecto/obtenProyectos?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse) => {
                setProyectos(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error al recuperar todos los proyectos: ' + error.response.data)
            });
    }

    const handleChangeFecha = (date) => {
        setSelectedDate(date)
        const inicioSemana = startOfWeek(date, { weekStartsOn: 1 }); // semana empieza en lunes
        const finSemana = endOfWeek(date, { weekStartsOn: 1 });
        setFechaInicioSelected(inicioSemana)
        setFechaFinSelected(finSemana)
    }


    useEffect(() => {
        obtenerProyectos();
    }, [])

    return (
        <Container style={{marginTop: '1em'}}>
            <Row>
                <Col><h3 style={{textAlign: 'center'}}>Reporte de omisiones</h3></Col>
            </Row>
            <Row className="justify-content-md-center" >
                <Col md={8}>
                    <Table striped hover>
                        <tbody>
                            <tr>
                                <td style={{width: '50%'}}>
                                    <label>Proyecto: </label>
                                </td>
                                <td style={{width: '50%'}}>
                                    <Form.Select
                                        onChange={event => { setProyectoSelected(event.target.value) }}
                                    >
                                        <option key="opt_proyecto0" value={0}>Todos los proyectos</option>
                                        {
                                            proyectos.map(proyecto =>
                                                <option 
                                                    key={'opt_proyecto'+proyecto.IDPROYECTO}
                                                    value={proyecto.IDPROYECTO}
                                                >
                                                    {proyecto.NOMBREPROYECTO}
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>
                                    <label>Fecha inicio: </label>
                                </td>
                                <td>
                                    <DatePicker className='form-control' dateFormat="dd/MM/yyyy" 
                                        selected={fechaInicioSelected} 
                                        onChange={(fechaInicio) => setFechaInicioSelected(fechaInicio)} 
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Fecha fin: </label>
                                </td>
                                <td>
                                    <DatePicker className='form-control' dateFormat="dd/MM/yyyy" 
                                        selected={fechaFinSelected} 
                                        onChange={(fechaFin) => setFechaFinSelected(fechaFin)} 
                                    />
                                </td>
                            </tr> */}
                            <tr>
                                <td>
                                    Semana que se está consultando:
                                    <b>
                                        {selectedDate && (<div style={{ marginTop: '1em' }}><u>Lunes {format(fechaInicioSelected, 'dd/MM/yyyy')} - Domingo {format(fechaFinSelected, 'dd/MM/yyyy')}</u></div>)}
                                    </b>
                                </td>
                                <td>
                                <DatePicker
                                    className='form-control'
                                    selected={selectedDate}
                                    onChange={handleChangeFecha}
                                    dateFormat="dd/MM/yyyy"
                                    showWeekNumbers
                                    calendarStartDay={1}
                                    highlightDates={[selectedDate]}
                                    //minDate={fechaInicioProyecto}
                                    //maxDate={fechaFinProyecto}
                                />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    
                                </td>
                                <td>
                                    <Button
                                        className='btn btn-success'
                                        variant="success"
                                        onClick={exportarReporte}
                                    >
                                        Exportar reporte
                                    </Button>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container>
    )
}

export default ReporteOmisionesForm;